export default __webpack_public_path__ + "static/media/oswald_font.68f9cbb8.ttf";